import React, { useState, useEffect } from "react";
import "./styles/navbar.css";

function ThemeToggle({ toggleTheme }) {
  const isLight = document.documentElement.dataset.theme === "light";

  return (
    <button
      className="theme-toggle"
      onClick={toggleTheme}
      role="switch"
      aria-label="Toggle theme"
      aria-checked={isLight}
    >
      <span className="toggle-icon left">🌙</span>
      <span className="toggle-thumb"></span>
      <span className="toggle-icon right">☀️</span>
    </button>
  );
}

function Navbar() {
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 769);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 769);

    window.addEventListener("resize", onResize);

    return () => window.removeEventListener("resize", onResize);
  }, []);

  function toggleTheme() {
    const html = document.documentElement;

    const next =
      html.dataset.theme === "light"
        ? "dark"
        : "light";

    html.dataset.theme = next;

    localStorage.setItem("theme", next);
  }

  return (
    <nav className="navbar">
      <div className="navbar-inner">

        <div className="logo">
          <a href="/">
            <img
              src="/portfolio-logo.png"
              alt="Portfolio Logo"
            />
            <span>Joel R. George</span>
          </a>
        </div>

        <ul className={`nav-links ${open ? "open" : ""}`}>
          <li><a href="/">Home</a></li>
          <li><a href="/projects">Projects</a></li>
          <li><a href="/about">About</a></li>
          <li><a href="/contact">Contact</a></li>
          <li><a href="/LiegeTech">Liege</a></li>

          {isMobile && (
            <li className="mobile-toggle">
              <ThemeToggle toggleTheme={toggleTheme} />
            </li>
          )}
        </ul>

        <div className="nav-actions">
          {!isMobile && (
            <ThemeToggle toggleTheme={toggleTheme} />
          )}

          <div
            className={`hamburger ${open ? "open" : ""}`}
            onClick={() => setOpen(!open)}
          >
            <span />
            <span />
            <span />
          </div>
        </div>

      </div>
    </nav>
  );
}

export default Navbar;